interface ICustomEnum<T> {
  [key: string]: () => T;
}

interface ICustomSwitchParams<T> {
  (condition: any, cases: ICustomEnum<T>, defaultCase?: () => T): T;
}

export function CustomSwitchFunction<T>(condition: any, cases: ICustomEnum<T>, defaultCase?: () => T): T {
  const caseFunction = cases[condition];
  if (caseFunction) {
    return caseFunction();
  } else if (defaultCase) {
    return defaultCase();
  } else {
    throw new Error('No matching case found');
  }
}
